export default __webpack_public_path__ + "static/media/CAMARAnecesariaSilver.a301230e.svg";